import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { Button } from '@material-ui/core'
import clsx from 'clsx'
import moment from 'moment'
import { SearchWidget } from 'pages/HomePage/components'
import { ROUTES } from 'routes'
import { Footer, MainLayout, NavBar, PageContainer } from 'shared'
import { loadChampionship, loadResults, resetValue } from 'state/modules/championships'
import { CHAMPIONSHIP_TYPES } from 'utils/constants'
import { useQuery } from 'utils/hooks'

import {
  CountryOriginSection,
  DescriptionSection,
  DisciplinesSection,
  Header,
  OrganizationSection,
  PastEventsSection,
  PlaceHolderLoader,
  PointsSection,
  ResultsSection,
  UpcomingEventsSection
} from './components'
import { useStyles } from './ProfilePage.style'

const ProfilePage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const query = useQuery()
  const firstRender = useRef(true)
  const { slugUrlOrId } = useParams()

  const previewViewParam = query.get('previewView')
  const { championship, pending } = useSelector((state) => state.championships)

  const activeLoading = firstRender.current || pending

  useEffect(() => {
    dispatch(loadChampionship(slugUrlOrId))

    return () => dispatch(resetValue('championship'))
  }, [dispatch, slugUrlOrId])

  useEffect(() => {
    firstRender.current = false
  }, [])

  useEffect(() => {
    if (
      championship &&
      !!championship.disputedEventsCount &&
      championship.events.some((x) => x.hasResultsSheetFile)
    )
      dispatch(loadResults(championship.id))

    return () => {}
  }, [championship])

  const renderProfile = () => {
    const { type, loggedUserMetadata, events, disputedEventsCount, to } = championship

    const { canEdit } = loggedUserMetadata

    const canEditAdmin = canEdit && !previewViewParam

    const afterChampionship = moment().isAfter(moment(to))

    const eventAllResultSheet = disputedEventsCount && events.some((x) => x.hasResultsSheetFile)

    return (
      <div className={classes.container}>
        <Header canEdit={canEditAdmin} altMode={!!disputedEventsCount} />

        <div className={classes.body}>
          <div className={clsx(classes.mainContainer, !!eventAllResultSheet && 'alt')}>
            {!!eventAllResultSheet && (
              <div className={classes.resultsContainer}>
                <ResultsSection />
              </div>
            )}

            <div
              className={clsx(
                classes.rowContainer,
                canEditAdmin && 'adminMode',
                !!eventAllResultSheet && 'alt'
              )}>
              <div className={classes.leftColumn}>
                <DescriptionSection altMode={!!eventAllResultSheet} />

                {type === CHAMPIONSHIP_TYPES.POINTS.value && (
                  <PointsSection altMode={!!eventAllResultSheet} />
                )}

                <UpcomingEventsSection altMode={!!eventAllResultSheet} />

                <PastEventsSection altMode={!!eventAllResultSheet} />
              </div>

              <div className={classes.rightColumn}>
                {canEditAdmin && (
                  <div className={classes.actionButtonBlock}>
                    <Button
                      variant='contained'
                      color='primary'
                      to={`${ROUTES.CHAMPIONSHIPS.EDIT}/${slugUrlOrId}`}
                      className={classes.editButton}
                      disabled={afterChampionship}
                      component={Link}>
                      Editar campeonato
                    </Button>

                    <Link
                      to={`${ROUTES.CHAMPIONSHIPS.PROFILE}/${slugUrlOrId}?previewView=true`}
                      color='primary'
                      target='_blank'
                      className={classes.previewTitle}>
                      Vista Previa del Campeonato
                    </Link>
                  </div>
                )}

                <OrganizationSection />

                <DisciplinesSection />

                <CountryOriginSection />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderLoading = () => <PlaceHolderLoader />

  return (
    <MainLayout>
      <NavBar widget={(props) => <SearchWidget mini {...props} />} altMode />
      <PageContainer customContainerClassName={classes.container}>
        {!activeLoading ? renderProfile() : renderLoading()}
      </PageContainer>
      <Footer />
    </MainLayout>
  )
}

export default ProfilePage
